import request from '@/utils/request'

export function updateGameUpdateCfg(data) {
  return request({
    url: 'api/v1/hot-update/updateCfg',
    method: 'post',
    data: data
  })
}

export function getGameUpdateList(data) {
  return request({
    url: 'api/v1/hot-update/getList',
    method: 'post',
    data: data
  })
}

export function importGameUpdateLang(data) {
  return request({
    url: 'api/v1/hot-update/importCfg',
    method: 'post',
    data: data
  })
}

export function delGameUpdate(data) {
  return request({
    url: 'api/v1/hot-update/delCfg',
    method: 'delete',
    data: data
  })
}
